import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import DTOViajes from '../../../DTOs/Operaciones/DTOViajes'
const OpViajes: DTOViajes[] = []
const initialState = { OpViajes }

export const OpViajesSlice = createSlice({
  name: 'OpViajes',
  initialState: initialState,
  reducers: {
    resetOpViajes : (state, action: PayloadAction<string>) => {
      state.OpViajes =  []
    },  
    populateOpViajes : (state, action: PayloadAction<DTOViajes[]>) => {
        action.payload.forEach(element => {
            const index = state.OpViajes.findIndex(object => object.id === element.id)
            if (index<0) state.OpViajes.push(element)
        })
    },
    updateOpViajes : (state, action: PayloadAction<DTOViajes>) => {
      const i = state.OpViajes.findIndex(_element => _element.id === action.payload.id);
      console.log('valor de i: '+i)      
      if (i > -1) state.OpViajes[i] = action.payload;
      else state.OpViajes.push(action.payload);
      console.log('payload='+JSON.stringify(action.payload))
    },
    deleteOpViajes : (state, action: PayloadAction<number>) => {
      const newArr = state.OpViajes.filter(data => data.id != action.payload);
      state.OpViajes=newArr
    },
  },
})

export const { resetOpViajes, populateOpViajes, updateOpViajes, deleteOpViajes } = OpViajesSlice.actions;
export default OpViajesSlice.reducer;